import { createGlobalStyle } from 'styled-components';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';

export default createGlobalStyle`
@font-face {
    font-family: 'Nimbus Sans Light';
    src: url("data:font/woff;base64,${tokens.AssetFontNimbussansLightWoff}") format('woff'),
    url("data:font/woff2;base64,${tokens.AssetFontNimbussansLightWoff2}") format('woff2');
    font-stretch: normal;
    font-style: normal; 
    font-weight: normal;
}
@font-face {
    font-family: 'Nimbus Sans Regular';
    src: url("data:font/woff;base64,${tokens.AssetFontNimbussansRegularWoff2}") format('woff'),
    url("data:font/woff2;base64,${tokens.AssetFontNimbussansRegularWoff2}") format('woff2');
    font-stretch: normal;
    font-style: normal; 
    font-weight: normal;
}
@font-face {
    font-family: 'Nimbus Sans Italic';
    src: url("data:font/woff;base64,${tokens.AssetFontNimbussansItalicWoff2}") format('woff'),
    url("data:font/woff2;base64,${tokens.AssetFontNimbussansItalicWoff2}") format('woff2');
    font-stretch: normal;
    font-style: normal; 
    font-weight: normal;
}
@font-face {
    font-family: 'Nimbus Sans Bold';
    src: url("data:font/woff;base64,${tokens.AssetFontNimbussansBoldWoff2}") format('woff'),
    url("data:font/woff2;base64,${tokens.AssetFontNimbussansBoldWoff2}") format('woff2');
    font-stretch: normal;
    font-style: normal; 
    font-weight: normal;
}
@font-face {
    font-family: 'Nimbus Sans Black';
    src: url("data:font/woff;base64,${tokens.AssetFontNimbussansBlackWoff2}") format('woff'),
    url("data:font/woff2;base64,${tokens.AssetFontNimbussansBlackWoff2}") format('woff2');
    font-stretch: normal;
    font-style: normal; 
    font-weight: normal;
}
`;
